module.exports = __webpack_public_path__ + "static/img/img2-4.3116822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/img2-4.png
// module id = PZbw
// module chunks = 10